import { Button, Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ConsoleCard } from '../../components/ConsoleCard';
import { Image } from '../../components/Image';
import { theme } from '../../theme';
import { Description, Heading } from '../Chart/ChartHeading';
import { CardsCol, CardsRow } from '../Layout';
import { Page, PageHeading } from '../Page';
const StyledConsoleCard = styled(ConsoleCard) `
  .ant-card-body {
    padding: 36px 48px;
  }
`;
const StyledCol = styled(Col) `
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CTAHeading = styled(Heading) `
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.2;
`;
const CTADescription = styled(Description) `
  margin-bottom: 0;
`;
const CTASubDescription = styled(Description) `
  color: ${theme.greys.chateau};
`;
const CTAButton = styled(Button) `
  max-width: 144px;
`;
const StyledImage = styled(Image) `
  height: auto;
  width: 100%;
`;
export const FeatureUnavailable = (props) => {
    return (React.createElement(Page, null,
        React.createElement(PageHeading, null, props.pageHeading),
        React.createElement(CardsRow, null,
            React.createElement(CardsCol, { span: 24 },
                React.createElement(StyledConsoleCard, null,
                    React.createElement(Row, { gutter: 24 },
                        React.createElement(StyledCol, { span: "12" },
                            React.createElement(CTAHeading, null, props.ctaHeading),
                            React.createElement(CTADescription, null, props.ctaDescription),
                            React.createElement(CTASubDescription, null, props.ctaSubDescription),
                            React.createElement(CTAButton, { type: "primary", shape: "round", href: props.ctaLink, target: "_blank" }, "Learn More")),
                        React.createElement(StyledCol, { span: "12" },
                            React.createElement(StyledImage, { imagePath: props.imagePath }))))))));
};
